<template>
    <div>
        <div v-if="!isMobile" class="marques">
            <div class="router">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{$store.state.fast_category_name}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/MarquesList' }">{{langPage['catalogue-filtres-mods-marquesfiltre']['TXT_grossistes']}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{dataAll.nomBoutique}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <vendeur-info-board :vendeurData="dataAll"></vendeur-info-board>
            <div class="containerVendeur">
                <div class="proBox" v-loading="loading">
                    <div class="filter">
                        <div style=" position: sticky;top: 0;z-index: 4;">
                            <goodsFilter :id="id" :id_vendeur="vid" :filterList="filterList" :promotions="promotion"
                                         :support_categories_ids="support_categories_ids"
                                         :marques="dataAll.vendeurs_marques"
                                         @promos="promos" style=""></goodsFilter>
<!--                            <div class="coupon">-->
<!--                                <img src="../assets/img/vendeur/bg_1.png" alt/>-->
<!--                                <img src="../assets/img/vendeur/bg_2.png" alt/>-->
<!--                                <div>-->
<!--                                    <div class="friday">{{langPage['v4-vendeur']['TXT_couponblackfriday'] }}</div>-->
<!--                                    <div class="btn">{{langPage['v4-vendeur']['TXT_blackfriday19'] }}</div>-->
<!--                                    <p>-10% | {{langPage['v4-vendeur']['TXT_surlensemble'] }}</p>-->
<!--                                    <p>100€  {{langPage['v4-vendeur']['TXT_dachats'] }}</p>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="list">
                        <!--                <div class="conditions">-->
                        <!--                    <div class="condition">Filtre <img class="close" src="@/assets/img/productList/close.svg" alt=""></div>-->
                        <!--                    <div class="clear">Effacer les filtres</div>-->
                        <!--                </div>-->
                        <div class="screen">
                            <div class="nav">
                                <div class="rows">
                                    <img src="@/assets/img/productList/four_rows.png"
                                         v-if="rows == 3"
                                         alt
                                         @click="rows=4"/>
                                    <img src="@/assets/img/productList/four_rows_act.png"
                                         v-if="rows == 4"
                                         alt
                                         @click="rows=4"/>
                                </div>
                                <div class="rows">
                                    <img src="@/assets/img/productList/three_rows.png"
                                         v-if="rows == 4"
                                         alt
                                         @click="rows=3"/>
                                    <img src="@/assets/img/productList/three_rows_act.png"
                                         v-if="rows == 3"
                                         alt
                                         @click="rows=3"/>
                                </div>
                            </div>
                            <div class="nav">
                                <div class="num">{{count}} {{langPage['produits-details-declinaison']['TXT_articles']}}</div>
                                <div class="name">{{ langPage['catalogue-filtresrecherche']['TXT_trierpar'] }}</div>
                                <!--                        <div class="value"  @click="order == 'desc'?'asc':'desc'">Prix décroissants <i class="el-icon-arrow-down"></i></div>-->
                                <el-dropdown @command="handleCommand" style="min-width:80px">
                                <span class="el-dropdown-link">
                                    {{order.value}}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                                :command="item"
                                                v-for="(item,index) in menuList"
                                                :key="index"
                                        >{{item.value}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div
                                v-infinite-scroll="loadMore"
                                infinite-scroll-disabled="busy"
                                infinite-scroll-distance="10"
                                infinite-scroll-throttle-delay="10">
                            <template v-if="list.length>0">
                                <goodsList ref="goodList" @goDetail="goDetail"
                                           @pagination="onLoadMoreClick"
                                           :total="count"
                                           :rows="rows" :list="list" type="0">
                                </goodsList>
<!--                                <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">-->
<!--                                    <button-->
<!--                                            @click="onLoadMoreClick"-->
<!--                                            style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0"-->
<!--                                    >{{ langPage['v4-nouveautes']['TXT_chargerplusdeproduites'] }}-->
<!--                                    </button>-->
<!--                                </div>-->
                            </template>
                            <div v-else style="display: inline-flex;margin-left: 40%"> {{ langPage['boa-statistiques-catalogue-produits-liste']['TXT_aucunproduit'] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="mMarques">
            <vendeur-info-board :vendeurData="dataAll" class="vendeurInfoBoardItem"></vendeur-info-board>
            <div class="container mobileCommon">
                <div class="proBox" v-loading="loading">
                    <div class="list">
                        <div class="screen">
                            <div class="listTop">
                                <div class="num">{{count}} {{langPage['produits-details-declinaison']['TXT_articles']}}</div>
                                <div class="imgLogo" style="text-align: left">
                                    <div class="rows">
                                        <img src="@/assets/img/productList/two_rows.svg"
                                             v-if="rows == 1"
                                             alt
                                             @click="rows=2"/>
                                        <img src="@/assets/img/productList/two_rows_act.svg"
                                             v-if="rows == 2"
                                             alt
                                             @click="rows=2"/>
                                    </div>
                                    <div class="rows2">
                                        <img src="@/assets/img/productList/one_rows.svg"
                                             v-if="rows == 2"
                                             alt
                                             @click="rows=1"/>
                                        <img src="@/assets/img/productList/one_rows_act.svg"
                                             v-if="rows == 1"
                                             alt
                                             @click="rows=1"/>
                                    </div>
                                </div>
                            </div>
                            <div class="listTop">
                                <div @click="is_show_filter=!is_show_filter" class="blackBtn leftBlackBtn">
                                    <div align="center" style="font-size: 10pt">{{ langPage['v4-productlist']['TXT_filtres'] }}</div>
                                </div>
                                <div class="nav" style="text-align: right">
                                    <el-dropdown @command="handleCommand">
                                        <div class="sortContainer">
                                            <div class="el-dropdown-link sort" align="center">{{order.value}}
                                                <i class="el-icon-arrow-down el-icon--right"></i>
                                            </div>
                                        </div>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                    :command="item"
                                                    v-for="(item,index) in menuList"
                                                    :key="index"
                                            >{{item.value}}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>
                        <div v-infinite-scroll="loadMore"
                             infinite-scroll-disabled="busy"
                             infinite-scroll-distance="10"
                             infinite-scroll-throttle-delay="10">
                            <template v-if="list.length>0">
                                <goodsList :style="{'margin-left': `${rows===1?'10vw':'5vw'}`}" ref="goodList"
                                           @goDetail="goDetail" :rows="rows"
                                           @pagination="onLoadMoreClick"
                                           :total="count"
                                           :list="list" type="0">
                                </goodsList>
<!--                                <div v-if="is_show_loadMore" class="center" style="width:100%;margin-top:40px">-->
<!--                                    <button-->
<!--                                            @click="onLoadMoreClick"-->
<!--                                            style="margin:0 auto;display:block;width:300px;height:50px;line-height:50px;background:black;color:#fff;border:0;font-size: 10pt"-->
<!--                                    >{{ langPage['v4-nouveautes']['TXT_chargerplusdeproduites'] }}-->
<!--                                    </button>-->
<!--                                </div>-->
                            </template>
                            <div v-else style="display: inline-flex;margin-left: 40%">  {{ langPage['boa-statistiques-catalogue-produits-liste']['TXT_aucunproduit'] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--过滤器filter的抽屉-->
            <el-drawer
                    :visible.sync="is_show_filter"
                    direction="ltr"
                    size="90%">
                <div class="drawerContainer">
                    <div class="proBox" v-loading="loading">
                        <div class="filter">
                            <div style=" position: sticky;top: 0;z-index: 4;">
                                <goodsFilter :id="id" :id_vendeur="vid" :filterList="filterList" :promotions="promotion"
                                             :support_categories_ids="support_categories_ids"
                                             :marques="dataAll.vendeurs_marques"
                                             @chooseCategory="is_show_filter = false"
                                             @promos="promos" style=""></goodsFilter>
                            </div>
                        </div>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
    import fillBgBox from "../components/fillBgBox";
    import goodsList from "../components/goodsList";
    import goodsFilter from "../components/goodsFilter";
    import bottomNav from "../components/bottomNav";
    import svgIcon from "../components/svgIcon"
    import SvgIcon from "../components/svgIcon";
    import VendeurInfoBoard from "../components/vendeurInfoBoard";
    import {mapState} from "vuex";

    let formatUtils = require('../utils/format');

    export default {
        name: "marques",
        components: {
            VendeurInfoBoard,
            SvgIcon,
            goodsList,
            goodsFilter,
            bottomNav,
            fillBgBox
        },
        data() {
            return {
                isMobile: this.$store.state.isMobile,
                loading: false,
                menuList: [
                    {key: "prix_asc", value: "Prix croissant"},//价格升序
                    {key: "prix_desc", value: "Prix décroissant"},//价格降序
                    {key: "date_creation_asc", value: "Plus ancien"},//创建时间升序
                    {key: "date_creation_desc", value: "Plus récent"}//创建时间降序
                ], //下拉框所有条件
                order: {key: "date_creation_desc", value: "Plus récent"},//创建时间降序
                offset: 0,
                description: "", //商家描述
                currDiscount: [],//最近打折商品
                discountList: [], //折扣商品(对应有背景图的两个模块，如果这块数据没有直接渲染最近打折的商品)
                pages: 1,
                TotalCount: 0,
                busy: false,
                limit: 10,
                count: "", //一共多少个结果
                activeName: "0",
                show: false, //是否展示更多商家信息
                rows: 4,
                current: 1,
                list: [],
                topList: [],
                color: [],
                vid: "",
                categorie_id: "",
                totleDate: [],
                promotion: [], //打折百分比,
                linksroute: [],
                dataAll: {},
                catalogues: [], //商家经营目录
                bgList: [
                    require("../assets/img/home/bg04.svg"),
                    require("../assets/img/home/ver_bg.png")
                ],
                filterList: {
                    id_langue: localStorage.getItem("lang") || "fr", //语言
                    vendu_par: "", //销售方式
                    new: "", //是否为新品 1 0
                    favoris: "", //是否为收藏
                    reference: "", //货号
                    prix_debut: "", //起始价格
                    prix_fin: "", //最高价格
                    promotion_debut: "", //打折最低价格
                    promotion_fin: "", //打折最高价格
                    provenances: [], //产地
                    vendeurs: "", //商家
                    marques: [], //品牌
                    collections: [],
                    promotions: [],
                    compositions: [], //产品成分
                    caracteristiques: [], //产品特性
                    tendances: "", //品趋势
                    couleurs: [], //产品颜色
                    order: "date_creation_desc",
                    categories: [] //产品类型
                },
                vendeur_contact_data: {},//商家的联系数据，包括facebook等
                support_categories_ids: [], //商家支持的最顶级的产品类型
                is_show_loadMore: true,
                is_show_filter: false,
            };
        },
        computed: {
            id() {
                if (!this.dataAll.categories) return 11;
                return Object.keys(this.dataAll.categories)[0].split('-')[0];
            },
            langPage() {
              return this.$store.state['langPage']
            }
          },
        filters: {
            dateSubstring(value) {
                return value.slice(0, 10);
            },
            formatDate: formatUtils.parseTime
        },
        created() {
            let path = this.$route.path;
            let v_id = path.substring(path.lastIndexOf('/') + 1);
            let query = this.$route.query;
            if (v_id) this.vid = v_id;
            // this.filterList.categories.push(this.$store.state.fast_categoryId);//查找要按照最顶层菜单选择的类型
            if (query.categorie_ids) this.filterList.categories = query.categorie_ids.split(',');
            this.getInfo();
            this.getDiscount();
        },
        mounted() {
            this.loadMore()
            if (this.isMobile) {
                this.rows = 1;
            }
            this.$common.EventBus.$on("loadmore", () => {
                this.offset = 0;
                this.loadMore();
            });
        },
        watch: {
            current(val) {
                console.log(val);
            },
            rows(val) {
            }
        },
        methods: {
            goDetail(item) {
                let url = window.origin +
                    `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`;
                window.open(url,'_blank');
            },
            addFavorite() {
                if (!this.$store.state.token) {
                    return this.$message.error(this.$t("seller_marques.word3"));
                }
                let params = {};
                params.id_vendeur = this.vid;
                params.id_acheteur = localStorage.getItem("id_acheteur");
                let marqueIds = [];
                for (let marque of this.dataAll.vendeurs_marques) {
                    marqueIds.push(marque.id_vendeur_marque);
                }
                params.id_vendeur_marques = marqueIds.join(',');
                this.$api.favor.addSellerMarques(params).then(res => {
                    if (res.code !== 0) {
                        return this.$message.error(res.message);
                    }
                    if (res.data.supprimer === 0) {
                        this.$message.success(this.$t("seller_marques.word1"))
                    } else {
                        this.$message.success(this.$t("seller_marques.word2"))
                    }
                    this.getInfo()
                })
            },
            //获取商家信息
            getInfo() {
                let th = this;
                this.$api.order
                    .getInfo({
                        lang: localStorage.getItem("lang") || "fr",
                        id: th.vid
                    })
                    .then(res => {
                        if (res.code === 0) {
                            th.dataAll = res.data;
                            if (th.dataAll.statut!=1 || th.dataAll.statut_vendeur!=1) this.$router.push('/homepage');
                            // let arr = {};
                            let linksroute = [];
                            // let regOnec = idCategories.substring(0, 2) + '-'
                            // let regTow = idCategories.substring(0, 4) + '-'
                            for (var i in th.dataAll.categories) {
                                let categoryId = i.split("-")[1];
                                linksroute.push(categoryId); //一级导航
                                // th.support_categories_id_top = +categoryId;
                                for (var key in th.dataAll.categories[i]) {
                                    linksroute.push(key.split("-")[1]); //二级导航
                                    linksroute.push(th.dataAll.categories[i][key][0].name); //三级导航
                                }
                            }
                            // console.log('linksroute', linksroute)
                            let vendeursData = th.dataAll.vendeurs_datum.data;
                            vendeursData = JSON.parse(vendeursData);
                            this.vendeur_contact_data = vendeursData;
                            th.catalogues = vendeursData.type_produits;
                            // this.categoList = arr
                            this.linksroute = linksroute;
                            this.getCategoryFilter();
                        }
                    });
            },
            //没有打折产品获取最近打折的商品
            getProduction() {
                this.$api.order.getProduction({
                    page: 1,
                    pageSize: "5",
                    type: "others",
                    id_vendeur: this.vid
                })
                    .then(res => {
                        this.currDiscount = res.data.list;
                    })
            },
            promos(data) {
                if (data.length && data.length > 0) {
                    (this.filterList.promotion_debut =
                        data[0].promotions_langues[0].promotion_debut),
                        (this.filterList.promotion_fin =
                            data[0].promotions_langues[0].promotion_fin);
                } else {
                    (this.filterList.promotion_debut = ""),
                        (this.filterList.promotion_fin = "");
                }
                this.offset = 0;
                this.loadMore();
            },
            loadMore(pageData) {
                if (this.offset == this.pages) {
                    return;
                }
                this.busy = true;
                this.offset = this.offset < this.pages ? (this.offset += 1) : this.offset;
                this.getPList(pageData);
            },
            getPList(pageData = {
                page: 1,
                limit: this.$common.goodsListDefaultLimit,
            }) {
                let topDateList = [];
                //如果搜索的里面有多个category就把最外层菜单的category去掉，比如11
                if (this.filterList.categories.length>1) this.filterList.categories.remove(this.$store.state.fast_categoryId)
                this.loading = true;
                this.$api.vendeurs.vendeursProd(
                    {id_vendeur: this.vid},
                    {
                        ...this.filterList,
                        limit: pageData.limit,
                        page: pageData.page,
                    }
                )
                    .then(res => {
                        this.loading = false;
                        this.is_show_loadMore = true;
                        this.pages = res.pages;
                        // 设置连接地址是第一个颜色的链接地址
                        for (var key in res.results) {
                            res.results[key].url = `${this.$common.imgHost}Images/Boutiques/${res.results[key].id_vendeur}/Produits/fiche/${res.results[key].id_produit}-c.jpg`;
                            for (var key1 in res.results[key].produit_liee) {
                                res.results[key].produit_liee[key1].url = `${this.$common.imgHost}Images/Boutiques/${res.results[key].produit_liee[key1].id_vendeur}/Produits/fiche/${res.results[key].produit_liee[key1].id_produit}-c.jpg`;
                                if (key1 == 0) {
                                    res.results[key].produit_liee[key1].clicked = true;
                                } else {
                                    res.results[key].produit_liee[key1].clicked = false;
                                }
                            }
                        }
                        this.list = res.results;
                        // if (type != 'change') {
                        //     this.list = this.list.concat(res.results);
                        // } else {
                        //     this.list = res.results
                        // }
                        // this.list = this.list.concat(res.results);
                        this.count = res.count;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            handleCommand(val) {
                this.order = val;
                this.filterList.order = val.key;
                this.list = [];
                this.loadMore();
            },
            onContactIconClick(url) {
                window.open(url, '_blank')
            },
            //获取商家的优惠活动
            getDiscount() {
                let th = this;
                this.$api.order.getDiscount({
                    page: 1,
                    pageSize: "100",
                    remiseType: "remise",
                    isCollect: th.dataAll.isCollect,
                    idVendeur: th.vid
                }).then(res => {
                    this.discountList = res.data.list;
                    if (res.data.list.length < 1) {
                        th.getProduction();
                    }
                });
            },
            //获取优惠券的描述
            getCouponDescription(remise) {
                let description = 'Ce coupon est ';
                // '本优惠券是 实际金额折扣/百分比折扣 类型， 最低满100/最高满1000/无满减限制 ,可以减免 100元/10%,有效期为2010-2022/无有效期';
                if (remise.type === 'pourcentage') {
                    description += 'Pourcentage de réduction type,'
                } else description += 'Décote sur le montant réel type,';
                if (remise.montant_min) description += `minimum ${remise.montant_min},`;
                if (remise.montant_max) description += `Jusqu’à ${remise.montant_max},`;
                if (!remise.montant_min && !remise.montant_max) description += 'Pas de limitation du montant à utiliser,';
                description += `Réduction ${remise.montant} ${remise.type === 'pourcentage' ? '%' : '€'},`;
                if (remise.date_debut) description += `Valable pour ${remise.date_debut} `;
                if (remise.date_fin) description += `Valable jusqu’au ${remise.date_fin} `;
                if (!remise.date_debut && !remise.date_fin) description += `Pas de limitation dans le temps`;
                return description;
            },
            //当加载更多被点击了
            onLoadMoreClick(pageData) {
                this.is_show_loadMore = false;
                this.loadMore(pageData);
            },
            //获取产品的分类目录，给左边的过滤器使用
            getCategoryFilter() {
                let keys1Temp = Object.keys(this.dataAll.categories);
                let keys1 = [];
                keys1Temp.forEach(key => {
                    let categoryId = key.split('-')[0];//一级id
                    if (categoryId) {
                        let keys2Temp = Object.keys(this.dataAll.categories[key]);
                        let keys2 = [];
                        keys2Temp.forEach(key2 => {
                            let categoryId2 = key2.split('-')[0];//二级id
                            if (categoryId2) {
                                let keys3 = [];
                                for (let category3 of this.dataAll.categories[key][key2]) {
                                    keys3.push(category3.id_categorie)
                                }
                                keys2[categoryId2] = keys3;
                            }
                        })
                        keys1[categoryId] = keys2;
                    }
                });
                this.support_categories_ids = keys1;
            }
        }
    };
</script>

<style lang="less" scoped src="@/assets/viewCss/views/vendeur.less">
</style>
